// Czech formatting helpers. "Today" is fixed so the mock data stays meaningful.

export const TODAY = '2026-10-19'

const money = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 })

export function formatMoney(amount: number) {
  return `${amount < 0 ? '−' : ''}${money.format(Math.abs(amount))} Kč`
}

export function formatNumber(value: number) {
  return money.format(value)
}

/** `long` is "12. června 2027", without a weekday, so it fits "do …" and "budeme se brát …". */
export function formatDate(iso: string, style: 'short' | 'long' = 'short') {
  const date = new Date(`${iso}T12:00:00`)
  return style === 'long'
    ? date.toLocaleDateString('cs-CZ', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : date.toLocaleDateString('cs-CZ', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function daysBetween(fromIso: string, toIso: string) {
  const from = new Date(`${fromIso}T12:00:00`).getTime()
  const to = new Date(`${toIso}T12:00:00`).getTime()
  return Math.round((to - from) / 86_400_000)
}

/** "dní", "den", "dny": Czech plural by count. */
export function plural(count: number, one: string, few: string, many: string) {
  const abs = Math.abs(count)
  if (abs === 1) return one
  if (abs >= 2 && abs <= 4) return few
  return many
}

/** "Dnes", "Zítra", "Za 5 dní", "3 dny po termínu". */
export function relativeDue(iso: string) {
  const days = daysBetween(TODAY, iso)
  if (days === 0) return 'Dnes'
  if (days === 1) return 'Zítra'
  if (days > 1) return `Za ${days} ${plural(days, 'den', 'dny', 'dní')}`
  const late = -days
  return `${late} ${plural(late, 'den', 'dny', 'dní')} po termínu`
}

export function isOverdue(iso: string | null) {
  return iso !== null && daysBetween(TODAY, iso) < 0
}

export function isWithinDays(iso: string | null, days: number) {
  if (iso === null) return false
  const diff = daysBetween(TODAY, iso)
  return diff >= 0 && diff <= days
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
}

let counter = 0
/** Ids for items created during the session. */
export function newId(prefix: string) {
  counter += 1
  return `${prefix}-new-${counter}`
}
